import { makeStyles } from "@material-ui/core"

export default makeStyles(() => ({
  tab: {
    minWidth: 80,
    width: 80,
  },
}))
